import React from "react";
import Page from "../components/Page";

// Import
import { useSelector } from "react-redux";
import { useSubmitForm } from "../hooks/useSubmitForm";
import { renderCollection } from "../util/renderCollection";
import { usePullData } from "../hooks/usePullData";
import { v4 as uuid } from "uuid";

// Import for Display
import LoadingPage from "./LoadingPage";
import Donate from "../components/Donate";

function DonatePage() {
  // Accessing data.
  const singleTypeSlug = "donate";
  const { data } = useSelector((state) => state.cms);
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;

  const collectionSlug = "shop-items";
  const collectionData = data[collectionSlug];

  console.log(cmsData);

  // Only load if data has returned.
  if (!cmsData) return <LoadingPage />;
  return (
    <Page data-wf-page="635a9b7699981b4f95995cb9" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="container w-container">
          <div className="w-row">
            <div className="w-col w-col-6">
            {cmsData.GearShopLink && (
                <a 
                  href={cmsData.GearShopLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="button w-button"
                  style={{ 
                    display: 'block',
                    marginBottom: '20px',
                    textAlign: 'center'
                  }}
                >
                  Visit Our Gear Shop
                </a>
              )}
              {/* Render our shop-items. */}
              <div className="w-layout-grid">{renderCollection(CollectionEntry, collectionData, collectionSlug)}</div>
            </div>

            {/* The Donate Form */}
            <div className="stickyform w-col w-col-6">
              <div className="formblockcontact donateform w-form">
                <Donate />
              </div>
            </div>

          </div>
        </div>
      </div>
    </Page>
  );
}

// Pulls shop-items.
const CollectionEntry = (props) => {
  let data = usePullData(props);
  //console.log(data);

  return (
    <div className="shop-item" key={uuid()}>
      <img src={data.photo.data && data.photo.data.attributes.url} loading="lazy" alt="" />
      <h4>{data.title}</h4>
      <div>{data.price}</div>
    </div>
  );
};
export default DonatePage;
